import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge, Card, CardBody, Col, Row } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import AppContext from '../../context/Context';
import { settingsRoutes, testSettingsItems } from '../../routes';
import { filterRoutesByPermissions } from '../../helpers/permissions';
import SettingsUserManagement from './SettingsUserManagement';

const renderSettingsGroups = (groups, locationPathname) =>
  (groups || []).map(section => (
    <div key={section.to} className="med-period-settings-group">
      <Link to={section.to} className="med-period-settings-group__head">
        <span>{section.name}</span>
        <FontAwesomeIcon icon="angle-right" />
      </Link>
      <div className="med-period-settings-group__children">
        {(section.children || []).map(child => (
          <Link
            key={child.to}
            to={child.to}
            className={classNames('med-period-settings-link', {
              'is-active': locationPathname === child.to
            })}
          >
            <span>{child.name}</span>
          </Link>
        ))}
      </div>
    </div>
  ));

const TestUserSettings = ({ location }) => {
  const { user, setUser } = useContext(AppContext);

  const visibleSettingsGroups = useMemo(
    () => filterRoutesByPermissions(settingsRoutes.children || [], user),
    [user]
  );
  const visibleTestSettingsItems = useMemo(() => filterRoutesByPermissions(testSettingsItems, user), [user]);

  return (
    <div>
      <Card className="border-0 shadow-sm mb-3">
        <CardBody className="med-settings-shell-card">
          <div className="d-flex flex-column flex-xl-row align-items-xl-center justify-content-between">
            <div className="mb-3 mb-xl-0">
              <Badge color="soft-primary" pill className="mb-2">
                Test sozlamalari
              </Badge>
              <h3 className="mb-1">Foydalanuvchilar boshqaruvi</h3>
              <p className="text-600 mb-0">
                Test va p-admin oqimida ishlaydigan akkauntlarni shu bo`limdan qo`shing, tahrirlang va arxivlang.
              </p>
            </div>

            <div className="d-flex flex-wrap">
              <Badge color="soft-info" pill className="mr-2 mb-2">
                Admin nazorati
              </Badge>
              <Badge color="soft-success" pill className="mb-2">
                Test paneliga ulangan
              </Badge>
            </div>
          </div>
        </CardBody>
      </Card>

      <Row>
        <Col xl={4} className="mb-3">
          <Card className="border-0 shadow-sm mb-3">
            <CardBody className="med-settings-shell-card">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div>
                  <Badge color="soft-primary" pill>
                    Sozlamalar
                  </Badge>
                  <h5 className="mb-1 mt-2">Bo'limlar ko'rinishi</h5>
                  <p className="text-500 mb-0">Asosiy sozlama bo`limlari shu joyda ko`rinadi.</p>
                </div>
                <div className="med-settings-shell-icon">
                  <FontAwesomeIcon icon="cog" />
                </div>
              </div>

              <div className="med-period-settings-layout">{renderSettingsGroups(visibleSettingsGroups, location.pathname)}</div>
            </CardBody>
          </Card>

          <Card className="border-0 shadow-sm">
            <CardBody className="med-settings-shell-card">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div>
                  <Badge color="soft-info" pill>
                    Test paneli
                  </Badge>
                  <h5 className="mb-1 mt-2">Tezkor yo'nalishlar</h5>
                  <p className="text-500 mb-0">Test sozlamalari ichidagi faol bo`limlar shu yerda turadi.</p>
                </div>
                <div className="med-settings-shell-icon">
                  <FontAwesomeIcon icon="stream" />
                </div>
              </div>

              <div className="med-period-quick-links">
                {visibleTestSettingsItems.map(item => (
                  <Link
                    key={item.to}
                    to={item.to}
                    className={classNames('med-period-quick-link', {
                      'is-active': location.pathname === item.to
                    })}
                  >
                    <span>{item.name}</span>
                    <FontAwesomeIcon icon="angle-right" />
                  </Link>
                ))}
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col xl={8}>
          <SettingsUserManagement currentUser={user} onCurrentUserUpdate={setUser} />
        </Col>
      </Row>
    </div>
  );
};

TestUserSettings.propTypes = {
  location: PropTypes.object.isRequired
};

export default withRouter(TestUserSettings);
